<template>
  <div
    :class="[
      'side',
      isShow ? 'noexpand' : 'expand',
      { 'other-page': !is_home },
    ]"
  >
    <img
      v-if="isShow"
      class="arrow"
      src="https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/side_right_arrow.png"
      @click="chageShow"
    />
    <img
      v-else
      class="arrow"
      src="https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/side_left_arrow.png"
      @click="chageShow"
    />
    <div class="content" @click="chageShow">
      <div class="download">
        <img
          @click="go('https://www.facebook.com/profile.php?id=100083216304166')"
          src="https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/fb_down.png"
        />
        <img
          @click="
            go('https://play.google.com/store/apps/details?id=com.ddj.vn')
          "
          src="https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/google_down.png"
        />
        <img
          @click="go('https://apps.apple.com/app/1619055257')"
          src="https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/apple_down.png"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isShow: true,
      state: this.$store.state,
      // m: false,
      // android: true,
    };
  },
  computed: {
    cur_route() {
      return this.state.currentRoute;
    },

    // 是否在首页
    is_home() {
      return this.cur_route == 'Home';
    },
  },
  methods: {
    chageShow() {
      this.isShow = !this.isShow;
    },

    go(url) {
      window.open(url);
    },
  },
};
</script>
<style scoped lang="scss">
@keyframes float {
  0% {
    transform: translatey(0px);
  }

  50% {
    transform: translatey(-20px);
  }

  100% {
    transform: translatey(0px);
  }
}

@keyframes noexpand {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(100%);
  }
}

@keyframes expand {
  0% {
    transform: translateX(100%);
  }

  100% {
    transform: translateX(0);
  }
}

@media screen and (max-width: 768px) {
  .side {
    display: none;
  }
}

.side {
  position: fixed;
  width: 165px;
  height: 489px;
  top: calc(50% - 340px);
  right: 0;
  z-index: 1000;
  transform: translatey(0px);
  animation: float 3s ease-in-out infinite;

  &.other-page {
    position: absolute;
    top: 330px;
  }

  &.noexpand {
    //收起
    animation: expand 0.5s ease-in 1;
    animation-fill-mode: forwards;
  }

  &.expand {
    //展开
    animation: noexpand 0.5s ease-in 1;
    animation-fill-mode: forwards;
  }

  > .arrow {
    cursor: pointer;
    position: absolute;
    top: 129px;
    left: -41px;
    width: 41px;
    height: 63px;
  }

  > .content {
    width: 165px;
    height: 489px;
    background-image: url('https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/side_full.png');
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;

    > .download {
      display: flex;
      flex-direction: column;
      position: absolute;
      right: 14px;
      bottom: 146px;

      > img {
        width: 136px;
        height: 43px;
        opacity: 0.9;
        margin-bottom: 14px;

        &:last-child {
          margin-bottom: 0;
        }

        &:hover {
          opacity: 1;
        }
      }
    }
  }
}
</style>